import { render, staticRenderFns } from "./SmsStats.vue?vue&type=template&id=2b7d2b92&scoped=true&"
import script from "./SmsStats.vue?vue&type=script&lang=js&"
export * from "./SmsStats.vue?vue&type=script&lang=js&"
import style0 from "./SmsStats.vue?vue&type=style&index=0&id=2b7d2b92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7d2b92",
  null
  
)

export default component.exports